/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/ratingsAndReview/hooks/useRatingsHooks.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */

import PortalIdParser from 'PortalIdParser';
import { useMemo } from 'react';
import I18n from 'I18n';
import { useGetReviewTags, useSearchReviews } from '../queries/ratingsQueries.migrated';
import { RatingsTagMap } from '../../../constants/RatingsAndReviewConstants.migrated';

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/ratingsAndReview/hooks/useRatingsHooks.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useGetReviewTagsHelper = () => {
  const {
    ratingsTags
  } = useGetReviewTags();
  const invertObject = object => {
    const newObj = {};
    Object.keys(object).forEach(key => newObj[object[key]] = key);
    return newObj;
  };
  const ratingsTagKeysMap = useMemo(() => {
    if (!ratingsTags) {
      return undefined;
    }
    return ratingsTags.reduce((prev, current) => {
      const newState = prev;
      newState[current.group] = invertObject(current.values);
      return newState;
    }, {});
  }, [ratingsTags]);
  const getReviewTags = reviewGroup => {
    const likeValuesGroup = (ratingsTags || []).find(entry => entry.group === reviewGroup);
    if (!likeValuesGroup) {
      return [];
    }
    return Object.entries(likeValuesGroup.values).map(([ratingTag, value]) => {
      const key = ratingTag;
      return {
        value,
        text: I18n.text(RatingsTagMap[key])
      };
    });
  };
  return {
    getReviewTags,
    ratingsTagKeysMap
  };
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/ratingsAndReview/hooks/useRatingsHooks.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useGetPreviousReview = ({
  entityId,
  reviewTypes,
  reviewerPortalId = PortalIdParser.getPortalIdFromPath(),
  reviewerUserId
}) => {
  var _searchReview$reviews;
  const {
    searchReview,
    refetchSearchReview
  } = useSearchReviews({
    entityId,
    limit: 1,
    offset: 0,
    reviewTypes,
    reviewerPortalId,
    reviewerUserId,
    sortFields: ['NEWEST']
  });
  const previousReview = searchReview === null || searchReview === void 0 || (_searchReview$reviews = searchReview.reviews) === null || _searchReview$reviews === void 0 ? void 0 : _searchReview$reviews[0];
  return {
    previousReview,
    refetchSearchReview
  };
};